<template>
  <div class="sensitive fs-warning">
    {{ $t('message["345"]') }}
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>

<style lang="scss" scoped>
.sensitive {
  padding: 12px 0;
  line-height: 1.5;
}
</style>
